import { array, intersection, object, record, string, TypeOf } from 'zod';

import { Link } from './common';

/* ------------------------------ BannerImages ------------------------------ */

export const BannerImages = intersection(
    object({
        master: string(),
    }),
    record(string(), string().optional()),
);

export type BannerImages = TypeOf<typeof BannerImages>;

/* --------------------------------- Banner --------------------------------- */

export const Banner = object({
    id: string(),
    name: string().optional(),
    image: BannerImages.optional(),
    link: Link.optional(),
});

export type Banner = TypeOf<typeof Banner>;

/* ------------------------------- AllBanners ------------------------------- */

export const AllBanners = object({
    data: array(Banner),
});

export type AllBanners = TypeOf<typeof AllBanners>;

/* -------------------------------- Responses ------------------------------- */

export const BannerResponse = object({
    bannerId: string().optional(),
});

export type BannerResponse = TypeOf<typeof BannerResponse>;

export const AllBannersResponse = object({
    data: array(
        object({
            categories: array(string()),
            bannerId: string().optional(),
        }),
    ),
});

export type AllBannersResponse = TypeOf<typeof AllBannersResponse>;
